export default __webpack_public_path__ + "static/media/480_store05-es-mobile.820ed335.png";